module.exports = __webpack_public_path__ + "img/cloud-mobile.007372f5.png";